export function formatBRL(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatNumber(value, fractionDigits = 2) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return n.toLocaleString('pt-BR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}

export function formatPercent(value, fractionDigits = 1) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return `${formatNumber(n, fractionDigits)}%`;
}
